const sections = document.querySelectorAll(".marquu_sec");
console.log(sections);
[...sections].forEach((section) => {
  const checkbox = section.querySelector("input");
  section.classList.toggle("enable-animation");
  
});

$('.product-media-modal__content').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true, // Enable adaptive height by default
  responsive: [
    {
      breakpoint: 640,
      settings: {
        adaptiveHeight: false,
         speed: 0,
        cssEase: 'linear'  
      }
    }
  ]
});

$(document).on('click','.main-pro-slider',function() {
  var imageslick_index = $(this).data('slick-index');
  console.log('imageslick_index = '+imageslick_index);
  $('.product-media-modal__content').slick('slickGoTo', imageslick_index);
});


// $(document).on('click', '.deferred-media__poster', function() {
//   let video = $(this).next('.product-modal-images video').get(0);
//   if (video) {
//     video.muted = false;
//     video.controls = true;
//     let playPromise = video.play();
//     if (playPromise !== undefined) {
//       playPromise.catch(error => {
//         console.log("Autoplay blocked, trying again muted:", error);
//         video.muted = true;
//         video.play();
//       });
//     }
//   }
//   console.log('121212');
// });



// if($(window).width() < 767){
// $('.media-type-video span.product__media-icon.motion-reduce').click(function(e){
//     e.preventDefault();
//  $('span.deferred-media__poster-button.motion-reduce').click();
// });
// }